export default __webpack_public_path__ + "static/media/andes_a_la_selva_1.814abd9c.JPG";